"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FooterPrimaryContent_1 = __importDefault(require("./FooterPrimaryContent"));
exports.default = FooterPrimaryContent_1.default;
